<template>
    <div class="about-main" v-if="pageSetup != null">
        <div class="container">
            <div class="column-container" v-if="!isMobileChecker">
                <div class="col-left">
                    <div class="page-title">
                        <h1>{{ pageSetup.about_main.title }}</h1>
                    </div>
                    <div class="col-img"><img :src="pageSetup.about_main.img" alt=""></div>
                </div>
                <div class="col-right">
                    <div class="col-info">
                        <h2>{{ pageSetup.about_main.desc_title }}</h2>
                        <div class="col-desc" v-html="pageSetup.about_main.desc"></div>
                    </div>
                </div>
                
            </div>
            <div class="col-info-mobile" v-if="isMobileChecker">
                <div class="page-title">
                    <h1>{{ pageSetup.about_main.title }}</h1>
                </div>
                <div class="inner-content">
                    <h2>{{ pageSetup.about_main.desc_title }}</h2>
                    <div class="col-desc col-desc-up" v-html="pageSetup.about_main.desc"></div>
                    <div class="col-img col-img-mobile">
                        <img :src="pageSetup.about_main.img" alt="">
                    </div>
                    <div class="col-desc col-desc-down" v-html="pageSetup.about_main.desc"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-main-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-main.scss';
    @import '@/styles/components/about-page/respond/about-main-respond.scss';
</style>